/** Adapt server-owned permission copy to practice terminology, leaving permission IDs intact. */
export function practicePermissionCopy(
  copy: string,
  subject?: { singular: string; plural: string },
): string {
  const localized = subject
    ? copy.replace(/\bpatients?\b/gi, word => {
        const replacement = word.toLowerCase() === 'patients' ? subject.plural : subject.singular;
        return word[0] === word[0].toUpperCase()
          ? replacement[0].toUpperCase() + replacement.slice(1)
          : replacement;
      })
    : copy;
  return localized.replace(/\b(organization(?:al|s)?|org)(?=\b)/gi, word => {
    const practice = word.toLowerCase() === 'organizations' ? 'practices' : 'practice';
    return word[0] === word[0].toUpperCase()
      ? practice[0].toUpperCase() + practice.slice(1)
      : practice;
  });
}
